import type React from "react";

interface TableIconProps {
  className?: string;
  isSelected?: boolean;
}

export const TableFormatIcon: React.FC<TableIconProps> = ({ className, isSelected }) => (
  <svg
    style={{ width: "100%", height: "100%" }}
    width="240"
    height="98"
    viewBox="0 0 240 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_696_4555)">
      <g clipPath="url(#clip1_696_4555)">
        <rect width="259.185" height="16" transform="translate(23 23.5)" fill={isSelected ? "#7F56D9" : "#A4A7AE"} />
        <path
          d="M29 31.5C29 30.3954 29.8954 29.5 31 29.5H75.3393C76.4439 29.5 77.3393 30.3954 77.3393 31.5C77.3393 32.6046 76.4439 33.5 75.3393 33.5H31C29.8954 33.5 29 32.6046 29 31.5Z"
          fill="white"
        />
        <path
          d="M81.3394 31.5C81.3394 30.3954 82.2348 29.5 83.3394 29.5H174.762C175.867 29.5 176.762 30.3954 176.762 31.5C176.762 32.6046 175.867 33.5 174.762 33.5H83.3394C82.2348 33.5 81.3394 32.6046 81.3394 31.5Z"
          fill="white"
        />
        <path
          d="M180.762 31.5C180.762 30.3954 181.658 29.5 182.762 29.5H274.185C275.29 29.5 276.185 30.3954 276.185 31.5C276.185 32.6046 275.29 33.5 274.185 33.5H182.762C181.658 33.5 180.762 32.6046 180.762 31.5Z"
          fill="white"
        />
        <rect width="259.185" height="16" transform="translate(23 41.5)" fill="white" />
        <path
          opacity="0.3"
          d="M29 49.5C29 48.3954 29.8954 47.5 31 47.5H75.3393C76.4439 47.5 77.3393 48.3954 77.3393 49.5C77.3393 50.6046 76.4439 51.5 75.3393 51.5H31C29.8954 51.5 29 50.6046 29 49.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <path
          opacity="0.3"
          d="M81.3394 49.5C81.3394 48.3954 82.2348 47.5 83.3394 47.5H174.762C175.867 47.5 176.762 48.3954 176.762 49.5C176.762 50.6046 175.867 51.5 174.762 51.5H83.3394C82.2348 51.5 81.3394 50.6046 81.3394 49.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <path
          opacity="0.3"
          d="M180.762 49.5C180.762 48.3954 181.658 47.5 182.762 47.5H274.185C275.29 49.5 276.185 48.3954 276.185 49.5C276.185 50.6046 275.29 51.5 274.185 51.5H182.762C181.658 51.5 180.762 50.6046 180.762 49.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <rect width="259.185" height="16" transform="translate(23 59.5)" fill="white" />
        <path
          opacity="0.3"
          d="M29 67.5C29 66.3954 29.8954 65.5 31 65.5H75.3393C76.4439 65.5 77.3393 66.3954 77.3393 67.5C77.3393 68.6046 76.4439 69.5 75.3393 69.5H31C29.8954 69.5 29 68.6046 29 67.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <path
          opacity="0.3"
          d="M81.3394 67.5C81.3394 66.3954 82.2348 65.5 83.3394 65.5H174.762C175.867 65.5 176.762 66.3954 176.762 67.5C176.762 68.6046 175.867 69.5 174.762 69.5H83.3394C82.2348 69.5 81.3394 68.6046 81.3394 67.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <path
          opacity="0.3"
          d="M180.762 67.5C180.762 66.3954 181.658 65.5 182.762 65.5H274.185C275.29 65.5 276.185 66.3954 276.185 67.5C276.185 68.6046 275.29 69.5 274.185 69.5H182.762C181.658 69.5 180.762 68.6046 180.762 67.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <rect width="259.185" height="16" transform="translate(23 77.5)" fill="white" />
        <path
          opacity="0.3"
          d="M29 85.5C29 84.3954 29.8954 83.5 31 83.5H75.3393C76.4439 83.5 77.3393 84.3954 77.3393 85.5C77.3393 86.6046 76.4439 87.5 75.3393 87.5H31C29.8954 87.5 29 86.6046 29 85.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <path
          opacity="0.3"
          d="M81.3394 85.5C81.3394 84.3954 82.2348 83.5 83.3394 83.5H174.762C175.867 83.5 176.762 84.3954 176.762 85.5C176.762 86.6046 175.867 87.5 174.762 87.5H83.3394C82.2348 87.5 81.3394 86.6046 81.3394 85.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <path
          opacity="0.3"
          d="M180.762 85.5C180.762 84.3954 181.658 83.5 182.762 83.5H274.185C275.29 83.5 276.185 84.3954 276.185 85.5C276.185 86.6046 275.29 87.5 274.185 87.5H182.762C181.658 83.5 180.762 86.6046 180.762 85.5Z"
          fill={isSelected ? "#9E77ED" : "#A4A7AE"}
        />
        <rect width="259.185" height="16" transform="translate(23 95.5)" fill="white" />
      </g>
    </g>
    <path
      d="M10 1.5H230C234.971 1.5 239 5.52944 239 10.5V87.5C239 92.4706 234.971 96.5 230 96.5H10C5.02944 96.5 1 92.4706 1 87.5V10.5C1 5.52944 5.02944 1.5 10 1.5Z"
      stroke={isSelected ? "#7F56D9" : "#D5D7DA"}
      strokeWidth="2"
    />
    <defs>
      <clipPath id="clip0_696_4555">
        <path
          d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H230C235.523 0.5 240 4.97715 240 10.5V87.5C240 93.0229 235.523 97.5 230 97.5H10C4.47716 97.5 0 93.0229 0 87.5V10.5Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_696_4555">
        <path
          d="M23 29.5C23 26.1863 25.6863 23.5 29 23.5H276.185C279.499 23.5 282.185 26.1863 282.185 29.5V105.5C282.185 108.814 279.499 111.5 276.185 111.5H29C25.6863 111.5 23 108.814 23 105.5V29.5Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
